import { getIsAvailableRuleByType } from '@pages/ConfiguredEntity/helpers'

import { FIELD_VALUE_TYPE, SEARCH_RULE_TYPE } from '@constants'
import { ConfiguredColumn, RestrictionData } from '@types'

export const getQuickSearchCheckedState = (
  column: ConfiguredColumn,
  ruleType: SEARCH_RULE_TYPE,
  isBooleanSearchMode: boolean,
  defaultEntityRestrictions?: RestrictionData
): boolean => {
  // Boolean колонки не выбираются в check all. Их можно выбрать только прямым нажатием.
  // При этом режим быстрого поиска поменяется на isBooleanSearchMode
  const isBooleanColumn = column.valueType === FIELD_VALUE_TYPE.BOOLEAN

  if (isBooleanSearchMode !== isBooleanColumn) {
    return false
  }

  const isColumnPinnedByAdmin = defaultEntityRestrictions?.fix?.some(
    item => item.fieldCode === column?.code && item.value
  )

  const quickSearchPermission = column.restrictions?.quickSearchPermission
  const show = column.restrictions?.show

  const isRuleAvailable = Boolean(getIsAvailableRuleByType(column, ruleType))
  const isColumnVisible =
    show === undefined || show === 'true' || show === true || !!isColumnPinnedByAdmin
  const isQuickSearchAvailable =
    quickSearchPermission === undefined ||
    quickSearchPermission === 'true' ||
    quickSearchPermission === true
  const isColumnQSChecked = Boolean(column.restrictions?.quickSearchChoice)

  return isQuickSearchAvailable && isRuleAvailable && isColumnQSChecked && isColumnVisible
}
